import { bindRequestLogic } from './utils'
import MessageAfterConnectionTypes from '../actionTypes/messageAfterConnection'
import { messageAfterConnectionAPI } from '../api'

const getMessageAfterConnection = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.getMessageAfterConnections,
  type: MessageAfterConnectionTypes.GET_MESSAGE_AFTER_CONNECTIONS_REQUEST,
  successType:
    MessageAfterConnectionTypes.GET_MESSAGE_AFTER_CONNECTIONS_SUCCESS,
  failType: MessageAfterConnectionTypes.GET_MESSAGE_AFTER_CONNECTIONS_FAILED,
  isQueryParam: true,
  modelName: 'messageAfterConnection'
})

const getMessageAfterConnectionDetail = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.getMessageAfterConnection,
  type: MessageAfterConnectionTypes.GET_MESSAGE_AFTER_CONNECTION_DETAIL_REQUEST,
  successType:
    MessageAfterConnectionTypes.GET_MESSAGE_AFTER_CONNECTION_DETAIL_SUCCESS,
  failType:
    MessageAfterConnectionTypes.GET_MESSAGE_AFTER_CONNECTION_DETAIL_FAILED
})

const addMessageAfterConnection = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.addMessageAfterConnection,
  type: MessageAfterConnectionTypes.ADD_MESSAGE_AFTER_CONNECTION_REQUEST,
  successType: MessageAfterConnectionTypes.ADD_MESSAGE_AFTER_CONNECTION_SUCCESS,
  failType: MessageAfterConnectionTypes.ADD_MESSAGE_AFTER_CONNECTION_FAILED
})

const deleteMessageAfterConnection = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.deleteMessageAfterConnection,
  type: MessageAfterConnectionTypes.DELETE_MESSAGE_AFTER_CONNECTION_REQUEST,
  successType:
    MessageAfterConnectionTypes.DELETE_MESSAGE_AFTER_CONNECTION_SUCCESS,
  failType: MessageAfterConnectionTypes.DELETE_MESSAGE_AFTER_CONNECTION_FAILED
})

const updateMessageAfterConnection = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.updateMessageAfterConnection,
  type: MessageAfterConnectionTypes.UPDATE_MESSAGE_AFTER_CONNECTION_REQUEST,
  successType:
    MessageAfterConnectionTypes.UPDATE_MESSAGE_AFTER_CONNECTION_SUCCESS,
  failType: MessageAfterConnectionTypes.UPDATE_MESSAGE_AFTER_CONNECTION_FAILED
})

const translateMessageAfterConnection = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.msgAfterConnectionTranslation,
  type: MessageAfterConnectionTypes.TRANSLATE_MESSAGE_AFTER_CONNECTION_REQUEST,
  successType:
    MessageAfterConnectionTypes.TRANSLATE_MESSAGE_AFTER_CONNECTION_SUCCESS,
  failType:
    MessageAfterConnectionTypes.TRANSLATE_MESSAGE_AFTER_CONNECTION_FAILED
})

const deleteMessageAfterConnectionTranslation = bindRequestLogic({
  clientFunc: messageAfterConnectionAPI.deleteMsgAfterConnectionTranslation,
  type: MessageAfterConnectionTypes.DELETE_MESSAGE_AFTER_CONNECTION_TRANSLATION_REQUEST,
  successType:
    MessageAfterConnectionTypes.DELETE_MESSAGE_AFTER_CONNECTION_TRANSLATION_SUCCESS,
  failType:
    MessageAfterConnectionTypes.DELETE_MESSAGE_AFTER_CONNECTION_TRANSLATION_FAILED
})

export default [
  getMessageAfterConnection,
  getMessageAfterConnectionDetail,
  translateMessageAfterConnection,
  addMessageAfterConnection,
  updateMessageAfterConnection,
  deleteMessageAfterConnection,
  deleteMessageAfterConnectionTranslation
]
